<template>
  <div>
    <div class="mt-3 mb-4 field-of-fields" style="width: 75%; display: block; margin-left: auto; margin-right: auto;">
      <!-- <a href="https://www.goldcoastnannies.company/">
        <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" width="" height="117" alt="The Nanny Company" style="" id='' class="center">
      </a> -->
      <h1 class="center">Client Application - Interim Care</h1>
      <hr>
      <h3 style="">Contact Information</h3>
      <hr style="margin-top: 3px; margin-bottom: -5px;">
      <label>Family Name*</label>
      <input type="text" class="form-control" placeholder="eg. Smith" v-model="familyName">
      <!-- <label style="color: red; margin-top: 3px;" v-if="!familyName && submitClicked">This field is required.</label> -->
      <p class="required-message" v-if="!familyName && submitClicked">This field is required.</p>
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Mother's First Name*</label>
            <input type="text" class="form-control" v-model="motherFirst">
            <p class="required-message" v-if="!motherFirst && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Mother's Last Name*</label>
            <input type="text" class="form-control" v-model="motherLast">
            <p class="required-message" v-if="!motherLast && submitClicked">This field is required.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Mother's Email Address*</label>
            <input type="text" class="form-control" v-model="motherEmail" placeholder="You will be our primary contact for all communication.">
            <p class="required-message" v-if="!motherEmail && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Mother's Phone Number*</label>
            <input type="text" class="form-control" v-model="motherPhone" placeholder="Please include area code.">
            <p class="required-message" v-if="!motherPhone && submitClicked">This field is required.</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Father's First Name*</label>
            <input type="text" class="form-control" v-model="fatherFirst">
            <p class="required-message" v-if="!fatherFirst && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Father's Last Name*</label>
            <input type="text" class="form-control" v-model="fatherLast">
            <p class="required-message" v-if="!fatherLast && submitClicked">This field is required.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Father's Email Address*</label>
            <input type="text" class="form-control" v-model="fatherEmail" placeholder="">
            <p class="required-message" v-if="!fatherEmail && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Father's Phone Number*</label>
            <input type="text" class="form-control" v-model="fatherPhone" placeholder="Please include area code.">
            <p class="required-message" v-if="!fatherPhone && submitClicked">This field is required.</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <div>
            <label>Street Address*</label>
            <input type="text" class="form-control" v-model="address">
            <p class="required-message" v-if="!address && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div>
            <label>City*</label>
            <input type="text" class="form-control" v-model="city">
            <p class="required-message" v-if="!city && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div>
            <label>Postal Code*</label>
            <input type="text" class="form-control" v-model="postalCode">
            <p class="required-message" v-if="!postalCode && submitClicked">This field is required.</p>
          </div>
        </div>
      </div>
      <label>Which is the best and most prompt way we can get into contact with you?*</label>
      <div class="form-check pl-4">
        <!-- <input class="form-check-input" type="radio" name="preferredCommRadios" v-model="preferredComm"> -->
        <input class="form-check-input" type="radio" value="Email" v-model="preferredComm">
        <label class="form-check-label ml-1" for="exampleRadios1">
          Email
        </label>
      </div>
      <div class="form-check pl-4">
        <!-- <input class="form-check-input" type="radio" name="preferredCommRadios" v-model="preferredComm"> -->
        <input class="form-check-input" type="radio" value="Phone" v-model="preferredComm">
        <label class="form-check-label ml-1" for="exampleRadios2">
          Phone
        </label>
      </div>
      <p class="required-message" v-if="!preferredComm && submitClicked">This field is required.</p>
      <h3 style="" class="mt-5">Service Information</h3>
      <hr style="margin-top: 3px; margin-bottom: -5px;">
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Child Name*</label>
            <input type="text" class="form-control" v-model="child1">
            <p class="required-message" v-if="!child1 && submitClicked">This field is required.</p>
            <label>Child Name</label>
            <input type="text" class="form-control" v-model="child2">
            <label>Child Name</label>
            <input type="text" class="form-control" v-model="child3">
            <label>Child Name</label>
            <input type="text" class="form-control" v-model="child4">
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Birthday*</label>
            <!-- <input type="text" class="form-control" v-model="birthday1"> -->
            <!-- https://github.com/charliekassel/vuejs-datepicker/pull/163 -->
            <datepicker class="form-control" initial-view="year" v-model="birthday1" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
            <p class="required-message" v-if="!birthday1 && submitClicked">This field is required.</p>
            <label>Birthday</label>
            <!-- <input type="text" class="form-control" v-model="birthday2"> -->
            <datepicker class="form-control" initial-view="year" v-model="birthday2" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
            <label>Birthday</label>
            <!-- <input type="text" class="form-control" v-model="birthday3"> -->
            <datepicker class="form-control" initial-view="year" v-model="birthday3" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
            <label>Birthday</label>
            <!-- <input type="text" class="form-control" v-model="birthday4"> -->
            <datepicker class="form-control" initial-view="year" v-model="birthday4" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
          </div>
        </div>
      </div>
      <!-- <label>Days & Times Required*</label>
      <input type="text" class="form-control" v-model="schedule" placeholder="e.g. Monday & Wednesday 9-5"> -->
      <!-- <p class="required-message" v-if="!schedule && submitClicked">This field is required.</p> -->
      <div class="row">
        <!-- <div class="col-lg-3">
          <label>Position Required (check all that apply)*</label>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="Full-Time" v-model="positions">
            <label class="form-check-label">
              Full-Time
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="Part-Time" v-model="positions">
            <label class="form-check-label">
              Part-Time
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="Summer" v-model="positions">
            <label class="form-check-label">
              Summer
            </label>
          </div>
          <p class="required-message" v-if="!positions[0] && submitClicked">This field is required.</p>
        </div> -->
        <!-- <div class="col-lg-3">
          <label>Anticipated Duration*</label>
          <div class="form-check pl-4">
            <input class="form-check-input" type="radio" value="Short-term (less than 6 months)" v-model="duration">
            <label class="form-check-label ml-1" for="exampleRadios1">
              Short-term (less than 6 months)
            </label>
          </div>
          <div class="form-check pl-4">
            <input class="form-check-input" type="radio" value="Long-term (1 year +)" v-model="duration">
            <label class="form-check-label ml-1" for="exampleRadios2">
              Long-term (1 year +)
            </label>
          </div>
          <p class="required-message" v-if="!duration && submitClicked">This field is required.</p>
        </div> -->
        <div class="col-lg-6">
          <label>Anticipated Start Date*</label>
          <datepicker class="form-control" v-model="startDate" :disabled-dates="disabledDates" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
          <p class="required-message" v-if="!startDate && submitClicked">This field is required.</p>
        </div>
      </div>
      <label>Family Pets*</label>
      <input type="text" class="form-control" v-model="pets">
      <label>Notes</label>
      <textarea rows="4" class="form-control" v-model="notes" placeholder="Any other information you feel would help us get to know you a little better."></textarea>
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>How did you hear about us?*</label>
            <select class="form-control" v-model="referrer">
              <option>Instagram</option>
              <option>Facebook</option>
              <option>Google</option>
              <option>Word of Mouth</option>
            </select>
            <p class="required-message" v-if="!referrer && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-6" v-if="referrer == 'Word of Mouth'">
          <div>
            <label>Who is the friend who referred you?</label>
            <input type="text" class="form-control" v-model="referee">
          </div>
        </div>
      </div>
      <div class="" style="margin-top: 30px; margin-bottom: 80px;">
        <div style="display: block;">
          <button class="mylisting-button dark-button" style="float: right;" @click="submitApplication()">Submit</button>
        </div>
      </div>
      <div style="margin-bottom: 130px">
        <p v-if="requiredMissing" class="required-message" style="float: right;">A required field is missing, please check the form.</p>
      </div>

    </div>

    <modal name="required-missing-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>A required field is missing.</h2>
        <h4>Please review the form for error messages!</h4>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('required-missing-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="duplicate-email-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Your email is already in our system!</h2>
        <h4>Have you worked with us before? If you think this is an error, please contact us: sarah@goldcoastnannies.company</h4>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('duplicate-email-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="application-submitted-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Thank you for submitting your application!</h2>
        <h4>A member of our team will review it and be in touch with you shortly.</h4>
        <hr>
        <!-- <button class="mylisting-button secondary-button" @click="$modal.hide('application-submitted-modal')" style="">Close</button> -->
        <button class="mylisting-button secondary-button" @click="hideApplicationSubmittedModal()" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
// import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

export default {
  components: {
    Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data() {
    return {
      familyName: '',
      motherFirst: '',
      motherLast: '',
      motherEmail: '',
      motherPhone: '',
      fatherFirst: '',
      fatherLast: '',
      fatherEmail: '',
      fatherPhone: '',
      address: '',
      city: '',
      postalCode: '',
      preferredComm: '',
      child1: '',
      birthday1: '',
      child2: '',
      birthday2: '',
      child3: '',
      birthday3: '',
      child4: '',
      birthday4: '',
      schedule: '',
      positions: [],
      duration: '',
      startDate: '',
      pets: '',
      notes: '',
      referrer: '',
      referee: '',

      submitClicked: false,
      requiredMissing: false,
    }
  },
  computed: {
    disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      let today = new Date()
      let disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      }
      return disabledDates
    },
  },
  methods: {
    submitApplication() {
      this.submitClicked = true

      if (this.familyName && this.motherFirst && this.motherLast && this.motherEmail && this.motherPhone
          && this.fatherFirst && this.fatherLast && this.fatherEmail && this.fatherPhone
          && this.address && this.city && this.postalCode && this.child1 && this.birthday1
          // && this.positions[0] && this.duration
          && this.startDate && this.pets && this.referrer
      ){
        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide()
        },4000)

        // axios.post('/create-user/', {
        //   email: this.motherEmail,
        //   password: this.motherEmail,
        // })
        //   .then(res => {
        //     console.log('User resgistered!')
        //     console.log(res)
        //     console.log(res.data.pk)

        //     console.log(this.$store.getters.agencyID)
        //     console.log(this.$store.getters.agencyName)

        //     axios.patch('/api/people/'.concat(res.data.pk.toString())+'/',
        //       {
        //         agency: this.$store.getters.agencyID,
        //         agency_owner: this.$store.getters.agencyName,
        //         is_employer: true,
        //         status: 'Applied',
        //       }
        //     )
        //       .then(res => {
        //         console.log(res)
        //       })
        //       .catch(error => console.log(error))
        //   })
        //   .catch(error => console.log(error))

        this.$store.dispatch('registerUser', {email: this.motherEmail, password: this.motherEmail, user_type: 'employer', status: 'Applied', phone: this.motherPhone})
          .then(() => {
            console.log('Done registration')
            // Send myself an email notification that a new client started a quote
            this.$store.dispatch('sendEmail',
              {
                subject: 'New TNC Interim Care Client Application',
                message: 'New Interim Care Client Application submitted by: ' + this.motherFirst + ' ' + this.motherLast + ' | ' + this.motherEmail,
                // from: 'info@thrivehire.co',
                from: this.$store.getters.agencyFromEmail,
                email: this.$store.getters.enginehireAdminEmail,
                reply: this.$store.getters.agencyReplyEmail,
                // userID: this.aakashid,
                userID: 4,
              }
            )
            // this.$store.dispatch('sendEmail',
            //   {
            //     subject: 'New TNC Interim Care Client Application',
            //     message: 'New Interim Care Client Application submitted by: ' + this.motherFirst + ' ' + this.motherLast + ' | ' + this.motherEmail,
            //     // from: 'info@thrivehire.co',
            //     from: this.$store.getters.agencyFromEmail,
            //     // email: this.$store.getters.agencyAdminEmail,
            //     email: 'casualplacements@thenannycompany.ca',
            //     reply: this.$store.getters.agencyReplyEmail,
            //     // userID: this.aakashid,
            //     userID: 4,
            //   }
            // )

            if (this.startDate) {
              this.startDate = this.dateInDjangoFormat(this.startDate)
            }
            // if (!this.birthday2) {
            //   this.birthday2 = ''
            // }
            // if (!this.birthday3) {
            //   this.birthday3 = ''
            // }
            // if (!this.birthday4) {
            //   this.birthday4 = ''
            // }

            // Need to store all the contact info after creating the user
            axios.patch('/api/people/'+this.$store.getters.userID.toString()+'/', {
              selector1: 'Interim',
              employer_name: this.familyName,
              first_name: this.motherFirst,
              last_name: this.motherLast,
              phone: this.motherPhone,
              features: [this.fatherFirst, this.fatherLast, this.fatherEmail, this.fatherPhone],
              address1: this.address,
              postal_code: this.postalCode,
              city: this.city,
              selector2: this.preferredComm,
              features2: [this.child1, this.birthday1, this.child2, this.birthday2, this.child3, this.birthday3, this.child4, this.birthday4],
              overview: this.schedule,
              preferences: this.positions,
              selector3: this.duration,
              available_date: this.startDate,
              text_field1: this.pets,
              about_us: this.notes,
              marketing_source: this.referrer,
              selector4: this.referee,
            })
              .then(res => {
                console.log(res)
                this.$modal.show('application-submitted-modal')

                this.$store.dispatch('logout', 'no-redirect')

                // axios.post('/api/jobs/', {
                //   poster: this.$store.getters.userID,
                //   poster_name: this.firstName + ' ' + this.lastName,
                //   status: 'Quoted',
                //   // title: 'Mowing',
                //   description: this.note,
                //   job_type: 'Mowing',
                //   selector1: this.size,
                //   selector2: this.frequency,
                //   // date: this.startDate,
                //   // end_date: this.endDate,
                //   date: startDate,
                //   end_date: endDate,

                //   address1: this.address1,
                //   // address2: this.address2,
                //   postal_code: this.postalCode,
                //   city: this.city,
                //   provincestate: this.provinceState,
                //   country: this.country,

                //   agency: this.$store.getters.agencyID,
                //   agency_owner: this.$store.getters.agencyName,
                // })
                //   .then(res => {
                //     console.log(res)
                //     this.currentStep = 4
                //   })
                //   .catch(error => {
                //     console.log(error)
                //   })
              })
              .catch(error => {
                console.log(error)
              })
          })
          .catch(error => {
            console.log(error)
            this.$modal.show('duplicate-email-modal')
          })
      }
      else {
        // this.requiredMissing = true
        this.$modal.show('required-missing-modal')
      }
    },
    hideApplicationSubmittedModal() {
      window.location.href = 'https://www.goldcoastnannies.company/';
    },
  },
}
</script>

<style>
  .required-field {
    color: red !important;
    font-weight: 600 !important;
  }
  .required-message {
    color: red;
    font-family: 'Crimson Text';
    font-weight: 600;
    margin-top: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/employers/applications/InterimCare.vue